var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4V10H7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51012 15C4.16015 16.8399 5.39057 18.4187 7.01596 19.4985C8.64136 20.5783 10.5737 21.1006 12.5217 20.9866C14.4697 20.8726 16.328 20.1286 17.8164 18.8667C19.3048 17.6047 20.3427 15.8932 20.7738 13.9901C21.2048 12.0869 21.0056 10.0952 20.2063 8.31508C19.4069 6.53496 18.0506 5.06288 16.3418 4.12065C14.633 3.17843 12.6642 2.81711 10.7322 3.09116C8.80013 3.3652 7.00951 4.25975 5.63012 5.64001L1.00012 10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V13.25L15 15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityHistory);
export default __webpack_public_path__ + "static/media/activity-history.d143c8340833dbb191985044605378a7.svg";
export { ForwardRef as ReactComponent };